export default "assets/images/icons/error-f9091c1b.svg";